import { NgModule } from '@angular/core';

/**
 * Icons-Migration (Angular-20): Frueher `BootstrapIconsModule.pick(...)` aus
 * `ng-bootstrap-icons` (ein Angular-13-Build). Dessen Modul-Konstruktor macht
 * `inject(Icons)` und wirft unter Angular 20 im async-Bootstrap NG0203 (auch der
 * canary 13.1.2-canary.1 ist derselbe Angular-13-Build und behebt das nicht).
 *
 * bpweb nutzt jetzt durchgaengig die CSS-Icon-Schrift (`<i class="bi bi-…">`, die ueber
 * `bootstrap-icons` in angular.json geladen wird) statt der `<bi>`-Komponente. Leeres
 * No-Op-Modul, damit das bestehende `imports: [IconsModule]` in `app.module.ts` nicht
 * angefasst werden muss; das Entfernen dieses (wirkungslosen) Imports + das
 * Deinstallieren von `ng-bootstrap-icons` ist ein Folge-Schritt.
 */
@NgModule({})
export class IconsModule { }
